import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {AsyncPipe, NgOptimizedImage} from '@angular/common';
import {map} from "rxjs/operators";
import {ActiveFormService} from "../../../service/active-form.service";

@Component({
  selector: 'app-footer',
  imports: [NgOptimizedImage, AsyncPipe],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.sass',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {
  private activeFormService = inject(ActiveFormService);


  isIreg = this.activeFormService.getActiveForm().pipe(
    map(type => type?.toString().includes('IREG_') ?? false)
  )
}
